class DSGNNavTabs extends HTMLElement {
  connectedCallback() {
    this.pills = Array.from(this.querySelectorAll('.dsgn-nav-tabs__pill'));
    this.panels = Array.from(this.querySelectorAll('.dsgn-nav-tabs__panel'));

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.activate(pill.dataset.tab));
    });

    const sessionTab = sessionStorage.getItem('dsgn-active-tab');
    const urlTab = new URLSearchParams(location.search).get('tab');
    const tabParam = sessionTab || urlTab;
    if (tabParam) {
      if (sessionTab) sessionStorage.removeItem('dsgn-active-tab');
      const match = this.pills.find((p) => p.dataset.tabType === `tab_${tabParam}`);
      if (match) this.activate(match.dataset.tab);
    }
  }

  activate(tabId) {
    this.pills.forEach((pill) => {
      pill.setAttribute('aria-selected', pill.dataset.tab === tabId ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      panel.setAttribute('aria-hidden', panel.dataset.tab === tabId ? 'false' : 'true');
    });
  }
}

customElements.define('dsgn-nav-tabs', DSGNNavTabs);

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#dsgn-contact-form');
  if (form) {
    form.addEventListener('submit', () => {
      sessionStorage.setItem('dsgn-contact-sent', '1');
      sessionStorage.setItem('dsgn-active-tab', 'socials');
    });
  }

  const popup = document.querySelector('[data-contact-popup]');
  if (!popup) return;

  const sent = sessionStorage.getItem('dsgn-contact-sent') === '1';
  if (sent) {
    sessionStorage.removeItem('dsgn-contact-sent');
    requestAnimationFrame(() => popup.classList.add('is-visible'));
  } else if (popup.hasAttribute('data-auto-show')) {
    requestAnimationFrame(() => popup.classList.add('is-visible'));
  }

  const closePopup = () => {
    window.location.href = location.pathname + '?tab=socials';
  };
  popup.querySelector('[data-contact-popup-close]')?.addEventListener('click', closePopup);
  popup.addEventListener('click', (e) => {
    if (e.target === popup) closePopup();
  });
});
